import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { FULL_TEASER_SPLIT_CONVERTER_TOKEN, FullTeaserSplitConverter } from './full-teaser-split.component.converter'
import {
  FULL_TEASER_SPLIT_BOX_CONVERTER_TOKEN, FullTeaserSplitBoxConverter
} from './full-teaser-split-box/full-teaser-split-box.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        fullTeaserSplitFeature: {
          module: () => import('./full-teaser-split.module').then((m) => m.FullTeaserSplitModule),
          cmsComponents: ['full_teaser_split'],
        },
      }
    }),
    {
      provide: FULL_TEASER_SPLIT_CONVERTER_TOKEN,
      useExisting: FullTeaserSplitConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_teaser_split: FULL_TEASER_SPLIT_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: FULL_TEASER_SPLIT_BOX_CONVERTER_TOKEN,
      useClass: FullTeaserSplitBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        full_teaser_split_box: FULL_TEASER_SPLIT_BOX_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class FullTeaserSplitFeatureModule {}
